import {
	Splide
} from '@splidejs/splide';
import AOS from 'aos';
import 'add-to-calendar-button';

(function ($) {


	$(document).ready(function () {
		// Check if '.splide-logos' elements exist on the page
		if ($('.splide-posts').length > 0) {
			var elms = document.getElementsByClassName('splide-posts');
			for (var i = 0; i < elms.length; i++) {
				new Splide(elms[i], {
					perPage: 3,
					perMove: 1,
					arrows: false,
					gap: 40,
					type: 'loop',
					breakpoints: {
						1000: {
							perPage: 2,
						},

						767: {
							perPage: 1,
						},
					}
				}).mount();
			}
		}

	});


	$(document).ready(function () {
	if ($('.splide-images').length > 0) {
		var elms = document.getElementsByClassName('splide-images');
		for (var i = 0; i < elms.length; i++) {
			new Splide(elms[i], {
				perPage: 2,
				perMove: 1,
				arrows: false,
				gap: 40,
				padding: 100,
				type: 'loop',
				breakpoints: {
					1000: {
						perPage: 1,
					},
					600: {
						padding: 20,
					},

				}
			}).mount();
		}
	}
});

$(document).ready(function () {
	AOS.init({
		once: !0,
		duration: 800,
		easing: "data-aos-custom",
		offset: 100,
	});
});


})(jQuery);
